var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"index",staticStyle:{"width":"1200px","height":"400px","margin-left":"0px","margin-top":"0px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }